module.exports = __webpack_public_path__ + "img/PLUS_GRILLE_POINTAGE_DISABLE.054f13ad.svg";